module.exports = __webpack_public_path__ + "static/media/Lavaniya-Jimenez_160px.94bc7ad3.jpg";